import { api } from './client';
import type { Page } from './catalogs';


export interface ServiceActItem {
  id?: string;
  line_number: number;
  nomenclature_id: string;
  description?: string | null;
  quantity: string;
  uom_id?: string | null;
  price: string;
  discount_percent?: string;
  discount_amount?: string;
  amount_without_vat: string;
  vat_rate_id: string;
  vat_amount: string;
  total_amount: string;
  tax_purpose_id?: string | null;
  accounting_account_code?: string | null;
}

export interface ServiceActListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  contractor_id: string;
  total_amount: string;
  posted: boolean;
  deletion_mark: boolean;
  state: string;
  external_source?: string | null;
}

export interface ServiceAct extends ServiceActListItem {
  contract_id: string | null;
  advance_offset_mode?: 'AUTO' | 'NONE';
  project_id: string | null;
  customer_order_id: string | null;
  service_period_from: string | null;
  service_period_to: string | null;
  prices_include_vat: boolean;
  // ч.1374: «Враховувати ПДВ» / «Авторозрахунок ПДВ» (1С).
  vat_considered: boolean;
  vat_auto: boolean;
  amount_without_vat: string;
  vat_amount: string;
  posted_at: string | null;
  cancelled_at: string | null;
  cancellation_reason: string | null;
  comment: string | null;
  items: ServiceActItem[];
}

export interface ServiceActCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  contractor_id: string;
  contract_id?: string | null;
  advance_offset_mode?: 'AUTO' | 'NONE';
  project_id?: string | null;
  customer_order_id?: string | null;
  service_period_from?: string | null;
  service_period_to?: string | null;
  prices_include_vat?: boolean;
  vat_considered?: boolean;
  vat_auto?: boolean;
  comment?: string | null;
  items: ServiceActItem[];
}

export type ServiceActUpdate = Partial<ServiceActCreate>;

export const serviceActs = {
  list: (params?: {
    organization_id?: string;
    contractor_id?: string;
    posted?: boolean;
    state?: string;
    limit?: number;
    date_from?: string;
    date_to?: string;
  }) =>
    api.get<Page<ServiceActListItem>>('/service-acts', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<ServiceAct>(`/service-acts/${id}`).then((r) => r.data),
  create: (payload: ServiceActCreate) =>
    api.post<ServiceAct>('/service-acts', payload).then((r) => r.data),
  update: (id: string, payload: ServiceActUpdate) =>
    api.patch<ServiceAct>(`/service-acts/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/service-acts/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<ServiceAct>(`/service-acts/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<ServiceAct>(`/service-acts/${id}/unpost`).then((r) => r.data),
};
